import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import AnswerButtonGroup from "@/components/train/AnswerButtonGroup.vue";
import LogicalTransformer2DImg from "@/components/subject/LogicalTransformer2D/LogicalTransformer2DImg.vue";
import IceCubeItem from "@/components/subject/Cube/IceCubeItem.vue";
export default {
  name: "StereoProjectionRender",
  components: {
    IceCubeItem,
    LogicalTransformer2DImg,
    AnswerButtonGroup
  },
  props: {
    review: {
      type: Object,
      default: () => {
        return null;
      }
    },
    runtimeParams: {
      type: Object,
      default: () => {
        return null;
      }
    },
    reviewMode: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => {
        return null;
      }
    }
  },
  watch: {
    data() {
      this.init();
    }
  },
  data() {
    return {};
  },
  computed: {
    questionImages() {
      if (!this.runtimeParams || !this.data) {
        return [];
      }
      let runtimeParams = this.runtimeParams;
      if (typeof runtimeParams === 'string') {
        try {
          runtimeParams = JSON.parse(runtimeParams);
        } catch (e) {
          return [];
        }
      }
      const imgs = runtimeParams[this.data.questionIndex];
      return Array.isArray(imgs) ? imgs.filter(Boolean) : [];
    }
  },
  methods: {
    onChoosed(l) {
      this.$emit('answer', l && l.length > 0 ? l[0] : null);
    },
    init() {}
  },
  mounted() {
    this.init();
  }
};